"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderCellFixed = exports.StyledHeaderCellAuto = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const typings_1 = require("../../typings");
const styles_1 = require("../../styles");
const cellStyle = (props) => {
    const borders = (0, styles_1.borderStyle)(props);
    const color = (0, ui_theme_1.fromTheme)('color_text_secondary')(props);
    const fontSize = (0, ui_theme_1.fromTheme)('font_size')(props);
    const fontWeight = (0, ui_theme_1.fromTheme)('font_weight_bold')(props);
    const padding = (0, ui_theme_1.fromTheme)('spacing_medium')(props);
    return `
    ${styles_1.baseStyle}
    ${styles_1.stickyStyle}
    padding: ${props.id === typings_1.RowSelectionId ? `0 ${padding}` : padding};
    border-top: ${borders};
    color: ${color};
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    top: ${props.top}px;
    z-index: 2;
    vertical-align: ${props.id === typings_1.RowSelectionId ? 'middle' : 'top'};
    text-align: left;
    & > * {
      width: 100%;
    }
    & > span {
      display: flex;
    }
    & > span:last-of-type:not(:only-of-type) {
      margin-top: 0.5em;
    }
  `;
};
const minWidthStyle = (props) => `
  ${props.minWidth
    ? `
    min-width: ${typeof props.minWidth === 'string'
        ? props.minWidth
        : `${props.minWidth}px`};
  `
    : ''};
`;
const maxWidthStyle = (props) => `
  ${props.maxWidth
    ? `
    max-width: ${typeof props.maxWidth === 'string'
        ? props.maxWidth
        : `${props.maxWidth}px`};
  `
    : ''};
`;
const filterCellProps = (prop) => ['minWidth', 'maxWidth', 'fixed', 'width', 'top'].indexOf(prop) < 0;
exports.StyledHeaderCellAuto = (0, styled_1.default)('th', {
    shouldForwardProp: filterCellProps
}) `
  ${cellStyle};
  ${minWidthStyle};
  ${maxWidthStyle};
`;
exports.StyledHeaderCellFixed = (0, styled_1.default)('th', {
    shouldForwardProp: filterCellProps
}) `
  ${cellStyle};
  ${minWidthStyle};
  ${maxWidthStyle};
  ${({ width, minWidth }) => width
    ? `
      width: ${typeof width === 'string' ? width : `${width}px`};
      ${minWidth == null || minWidth === 0
        ? `min-width: ${typeof width === 'string' ? width : `${width}px`};`
        : ''}
    `
    : ''};
`;
//# sourceMappingURL=HeaderCell.styles.js.map